import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import Section from './Section';
import { SectionHeader } from './SectionHeader';
import { WhatsNewCard } from './WhatsNewCard';
import { Paths } from '../../components/RoutesPublic';
import { METEOR } from 'developer-docs-shared-components/config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WhatsNew = () => {
  const {
    isDesktop
  } = useViewport();
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      iconName: "recentlySelected",
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.mainLandingPage.whatsNew.header"
      })
    }), /*#__PURE__*/_jsxs(UICardGrid, {
      columnSize: isDesktop ? '400px' : undefined,
      className: "p-top-12",
      children: [/*#__PURE__*/_jsx(WhatsNewCard, {
        illustration: "beta",
        background: METEOR,
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.mainLandingPage.whatsNew.cards.uiExtensions.content"
        }),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.mainLandingPage.whatsNew.cards.uiExtensions.header"
        }),
        link: `${Paths.GUIDES}/crm/ui-extensions/overview`
      }), /*#__PURE__*/_jsx(WhatsNewCard, {
        illustration: "building",
        background: METEOR,
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.mainLandingPage.whatsNew.cards.sampleApp.content"
        }),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.mainLandingPage.whatsNew.cards.sampleApp.header"
        }),
        link: `${Paths.GUIDES}/crm/sample-projects/overview`
      })]
    })]
  });
};
export default WhatsNew;